/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Regionalpricingbadge_Suggestedprice3Inputs */

const id_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga yang disarankan`)
};

const ms_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga cadangan`)
};

const da_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foreslået pris`)
};

const de_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfohlener Preis`)
};

const en_us2_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested price`)
};

const es_es2_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio sugerido`)
};

const es_mx2_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio sugerido`)
};

const fil_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iminungkahing presyo`)
};

const fr_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix suggéré`)
};

const it_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo suggerito`)
};

const hu_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Javasolt ár`)
};

const nl_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorgestelde prijs`)
};

const no_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foreslått pris`)
};

const pl_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerowana cena`)
};

const pt_br2_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested price`)
};

const pt_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço sugerido`)
};

const ro_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preț sugerat`)
};

const fi_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehdotettu hinta`)
};

const sv_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekommenderat pris`)
};

const vi_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá đề xuất`)
};

const tr_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önerilen fiyat`)
};

const cs_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doporučená cena`)
};

const bg_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложена цена`)
};

const ru_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуемая цена`)
};

const uk_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендована ціна`)
};

const ar_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعر المقترح`)
};

const hi_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सुझाई गई कीमत`)
};

const th_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาที่แนะนำ`)
};

const ja_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推奨価格`)
};

const zh_cn2_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested price`)
};

const zh_hant1_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested price`)
};

const ko_components_regionalpricingbadge_suggestedprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Suggestedprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested price`)
};

/**
* | output |
* | --- |
* | "Suggested price" |
*
* @param {Components_Regionalpricingbadge_Suggestedprice3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_regionalpricingbadge_suggestedprice3 = /** @type {((inputs?: Components_Regionalpricingbadge_Suggestedprice3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Regionalpricingbadge_Suggestedprice3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "ms") return ms_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "da") return da_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "de") return de_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "en-US") return en_us2_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "es-ES") return es_es2_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "es-MX") return es_mx2_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "fil") return fil_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "fr") return fr_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "it") return it_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "hu") return hu_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "nl") return nl_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "no") return no_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "pl") return pl_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "pt-BR") return pt_br2_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "pt") return pt_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "ro") return ro_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "fi") return fi_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "sv") return sv_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "vi") return vi_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "tr") return tr_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "cs") return cs_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "bg") return bg_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "ru") return ru_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "uk") return uk_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "ar") return ar_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "hi") return hi_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "th") return th_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "ja") return ja_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_regionalpricingbadge_suggestedprice3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_regionalpricingbadge_suggestedprice3(inputs)
	return ko_components_regionalpricingbadge_suggestedprice3(inputs)
});
export { components_regionalpricingbadge_suggestedprice3 as "components.regionalPricingBadge.suggestedPrice" }